var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{attrs:{"to":"/"}},[_c('v-img',{attrs:{"src":require("../assets/img/logo/pua-logo.svg"),"height":"60px","width":"80px","contain":"","alt":"PUA Logo"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }